<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'App',
	data() {
		return {
			
		}
	}
}
</script>

<style>
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	background: url('./assets/images/dw_bg.png') no-repeat;
	background-size: 100% 100%;
	padding-left: 0.1rem;
	padding-right: 0.1rem;
	height: 100vh;
}
</style>
